// 产品卡片静态数据（首页 productionShow、产品中心 ProductCenter 共用）
// path（产品背景图）/ back（产品名称背景图）按列表内位置奇偶交替，
// 与原组件保持一致：偶数位用背景图1，奇数位用背景图2。

const productBg = [
	require('../assets/img/index/产品中心-产品背景图1.png'),
	require('../assets/img/index/产品中心-产品背景图2.png')
]

const nameBg = [
	require('../assets/img/index/产品中心-产品名称背景图1.png'),
	require('../assets/img/index/产品中心-产品名称背景图2.png')
]

// 产品核心信息（与背景无关的字段）
const facscopeB = {
	desc: 'Facscope B',
	devi: require('../assets/img/index/Facscope B.png'),
	index: '/FacscopeB',
	name: '自动细胞计数仪',
	cont: '基于明场显微镜的自动细胞计数仪 \n '
}

const cellogerMiniPlus = {
	desc: 'Celloger Mini Plus',
	devi: require('../assets/img/index/Celloger Mini Plus.png'),
	index: '/CellogerMiniPlus',
	name: '全自动活细胞成像分析系统',
	cont: ' 使用Celloger Mini Plus\n  进行实时细胞监测和分析,提高科研效率。'
}

const cellogerNano = {
	desc: 'Celloger Nano',
	devi: require('../assets/img/index/Celloger Nano.png'),
	index: 'CellogerNano',
	name: '活细胞影像仪',
	cont: '随时随地监测你的细胞。\n '
}

const cellogerPro = {
	desc: 'Celloger Pro',
	devi: require('../assets/img/index/Celloger Pro.png'),
	index: 'CellogerPro',
	name: '全自动活细胞成像分析系统',
	cont: '无缝成像，无限洞察。\n '
}

const cellogerStack = {
	desc: 'Celloger Stack',
	devi: require('../assets/img/index/Celloger Stack.png'),
	index: 'CellogerStack',
	name: '全自动细胞工厂成像仪',
	cont: '   无需从培养箱取出即可\n     把握细胞传代培养的最佳时机。'
}

const cellpuri = {
	desc: 'Cellpuri',
	devi: require('../assets/img/index/Cellpuri.png'),
	index: 'Cellpuri',
	name: '一次性细胞富集芯片',
	cont: '无需离心即可富集细胞。\n '
}

const slide = {
	desc: 'Slide',
	devi: require('../assets/img/index/Slide.png'),
	index: '/Slide',
	name: '一次性计数板',
	cont: '一款精确的一次性计数板。'
}

// 按列表内位置奇偶交替补充背景图字段
function withBackgrounds(list) {
	return list.map((product, i) => ({
		...product,
		path: productBg[i % 2],
		back: nameBg[i % 2]
	}))
}

const mixedCells = {
	desc: 'Mixed Cells',
	devi: require('../assets/img/index/Mixed Cells.png'),
	index: '/MixedCells',
	name: '病毒分离培养混合细胞',
	cont: '从细胞准备到病毒接种仅需2～3h，\n 省去传统复苏与传代。'
}

// 首页产品展示（8 个：5 台设备 + 3 款耗材）
export const homeProducts = withBackgrounds([
	facscopeB,
	cellogerMiniPlus,
	cellogerNano,
	cellogerPro,
	cellogerStack,
	cellpuri,
	slide,
	mixedCells
])

// 产品中心 - 实验室设备（5 个）
export const labEquipments = withBackgrounds([
	facscopeB,
	cellogerMiniPlus,
	cellogerNano,
	cellogerPro,
	cellogerStack
])

// 产品中心 - 实验室耗材（3 个）
export const labConsumables = withBackgrounds([
	cellpuri,
	slide,
	mixedCells
])
